import React, { FC } from 'react';
import styled from 'styled-components';

import { SituacaoTag } from 'view/component/Situacao/SituacaoTag';
import { SolicitacaoServicoPageViewProps } from '../SolicitacaoServicoPage';


interface SolicitacaoServicoPageHeaderDetalhesProps extends SolicitacaoServicoPageViewProps {}

export const SolicitacaoServicoPageHeaderDetalhes: FC<SolicitacaoServicoPageHeaderDetalhesProps> = ({idSolicitacao: id, solicitacao}) => {
  return <Detalhes>
    {id && <SituacaoTag situacao={solicitacao.situacao} />}
  </Detalhes>
}

const Detalhes = styled.div`
  margin-top: .35em;
`;
